import { t } from 'i18next';
import { mapValues } from 'lodash';
import { nonMandatoryStipulationType } from '.';
import { Yup } from '../../../services/common/validation';

const FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
const SUPPORTED_FORMATS = ['application/pdf', 'image/jpeg', 'image/png'];
const SUPPORTED_FORMATS_EXTENSIONS = ['pdf', 'jpg', 'png'];

const fileValidation = (key: string) => {
  return Yup.mixed()
    .test('fileSize', t('validation:tooLargeFile'), (value: any) => {
      if (!value) return true;
      if (Array.isArray(value) && value.length === 0) return true;
      if (Array.isArray(value) && value.length > 0 && !!value[0].file) {
        return value[0].file.size <= FILE_SIZE;
      }
      return value.size ? value.size <= FILE_SIZE : true;
    })
    .test('isRequired', t('validation:requiredField'), (value) => {
      if (key.includes(nonMandatoryStipulationType)) {
        return true;
      }
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return false;
      }
      return true;
    })
    .test(
      'fileFormat',
      t('validation:fileNotSupport', {
        formats: SUPPORTED_FORMATS_EXTENSIONS.join(', '),
      }),
      (value: any) => {
        if (!value) return true;
        if (Array.isArray(value) && value.length === 0) return true;
        let extension = value.mimeType;
        if (Array.isArray(value) && value.length > 0 && !!value[0].file) {
          extension = value[0].file?.type;
        }
        if (Array.isArray(value) && value.length > 0 && !value[0].file) {
          extension = value[0].mimeType;
        }
        return SUPPORTED_FORMATS.includes(extension);
      }
    );
};

export const validationSchemaForStep5 = Yup.lazy((obj) => {
  return Yup.object(
    mapValues(obj, (_, key) => {
      if (key.includes('credit-application-stipulation-')) {
        return fileValidation(key);
      }
      return Yup.string();
    })
  );
});
